import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import RestaurantDetail from "./pages/RestaurantDetail";
import PublicTrip from "./pages/PublicTrip";
import BlogIndex from "./pages/BlogIndex";
import BlogPost from "./pages/BlogPost";
import SubmitTruck from "./pages/SubmitTruck";
import AdminQueue from "./pages/AdminQueue";
import TruckEdit from "./pages/TruckEdit";
import CalgaryFoodScene from "./pages/CalgaryFoodScene";
import EdmontonHiddenGems from "./pages/EdmontonHiddenGems";
import BanffDiningGuide from "./pages/BanffDiningGuide";
import ResetPassword from "./pages/ResetPassword";
import FoodTrail from "./pages/FoodTrail";
import SeoLanding from "./pages/SeoLanding";
import About from "./pages/About";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import SampleItineraries from "./pages/SampleItineraries";
import SampleItinerary from "./pages/SampleItinerary";
import { SEO_LANDINGS } from "./data/seoLandings";

const root = ReactDOM.createRoot(document.getElementById("root"));
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/restaurants/:id" element={<RestaurantDetail />} />
          <Route path="/trip/:publicId" element={<PublicTrip />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/submit-truck" element={<SubmitTruck />} />
          <Route path="/admin" element={<AdminQueue />} />
          <Route path="/truck/edit/:token" element={<TruckEdit />} />
          <Route path="/calgary-food-scene" element={<CalgaryFoodScene />} />
          <Route path="/edmonton-hidden-gems" element={<EdmontonHiddenGems />} />
          <Route path="/banff-dining-guide" element={<BanffDiningGuide />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/trails/:id" element={<FoodTrail />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/sample-itineraries" element={<SampleItineraries />} />
          <Route path="/sample-itineraries/:slug" element={<SampleItinerary />} />
          {SEO_LANDINGS.map((l) => (
            <Route key={l.slug} path={`/${l.slug}`} element={<SeoLanding slug={l.slug} />} />
          ))}
          <Route path="/" element={<App />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
    </GoogleOAuthProvider>
  </React.StrictMode>,
);
